// extracted by mini-css-extract-plugin
export var content = "styles-module--content--gGUCT";
export var link = "styles-module--link--ZaC0u";
export var highlight = "styles-module--highlight--tWo4z";